/**
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import { LookupCollection } from './BaseCollection';
import type { MutationsObject } from '@kp/js-model';
import type { Dayjs } from 'dayjs';

export class Eigentuemerschaft extends BaseModel {
    id: number | null = null
    aktiv: boolean | null = false
    erstellt_am: Dayjs | null = null
    bearbeitet_am: Dayjs | null = null
    ersteller_id: number | null = null
    bearbeiter_id: number | null = null
    reihenfolge: number | null = null
    bezeichnung: string | null = null
    kurzbezeichnung: string | null = null
    finanzstelle: string | null = null
    apollon_visible: boolean | null = false
    ist_oeffentliche_hand: boolean | null = false

    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            ersteller_id: (id) => (Number(id) > 0 ? Number(id) : null),
            bearbeiter_id: (id) => (Number(id) > 0 ? Number(id) : null)
        };
    }

    getClassName(): string {
        return 'eigentuemerschaft';
    }
}

export class EigentuemerschaftCollection extends LookupCollection<Eigentuemerschaft> {
    protected modelCls = Eigentuemerschaft;
    getModelClassName(): string {
        return 'eigentuemerschaft'
    }
}
